var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-empty',{attrs:{"description":"该页面不存在或无法访问"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }